import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "remove--sprite",
  "use": "remove--sprite-usage",
  "viewBox": "0 0 10 12",
  "content": "<symbol viewBox=\"0 0 10 12\" xmlns=\"http://www.w3.org/2000/svg\" id=\"remove--sprite\">\n<path d=\"M7.66667 4V10.6667H2.33334V4H7.66667ZM6.66667 0H3.33334L2.66667 0.666667H0.333336V2H9.66667V0.666667H7.33334L6.66667 0ZM9 2.66667H1V10.6667C1 11.4 1.6 12 2.33334 12H7.66667C8.4 12 9 11.4 9 10.6667V2.66667Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol